import { Component } from 'react'

import i18n from '../../i18n'
import DefaultError from 'components/Error/DefaultError/DefaultError'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  // @TODO remove this method in favour of utils/getUserLanguage
  getUserLanguage() {
    const { bookLang } = this.props
    return bookLang === 'ca' ? 'ca' : 'es'
  }

  render() {
    const { children } = this.props
    const { hasError } = this.state
    if (hasError) {
      return (
        <DefaultError
          actionText={i18n.t('Por favor, inténtalo más tarde.')}
          description={i18n.t(
            'Algo salió mal... Estamos trabajando en ello para que vuelva a funcionar.'
          )}
          title={i18n.t('¡Oops!')}
        />
      )
    }
    return children
  }
}

export default ErrorBoundary
